import { render, staticRenderFns } from "./bug_report.vue?vue&type=template&id=662a2f56&scoped=true"
import script from "./bug_report.vue?vue&type=script&lang=js"
export * from "./bug_report.vue?vue&type=script&lang=js"
import style0 from "./bug_report.vue?vue&type=style&index=0&id=662a2f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a2f56",
  null
  
)

export default component.exports